import { Button } from "@sellar-io/components";
import { useMatch, useSearchParams } from "react-router";
import { useSignupContext } from "../../../../../hooks/useSignupContext.shared";
import { ProfilePicture } from "../../../../../components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { STOREFRONT_LINKS_PREVIEW } from "../../../../../constants/routes";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useSellarUser } from "../../../../../hooks";
import { useLocalStorage } from "usehooks-ts";
import { generateSignupContinueUrl } from "../../../../../utils/sellarHelpers";
import { zLayer } from "@sellar-io/components";

export const SignUpToAccessSticky = ({
  supplier,
}: {
  supplier: SupplierGetResponseType | undefined;
}) => {
  const isStorefrontLinkPreview = !!useMatch(STOREFRONT_LINKS_PREVIEW);
  const { business } = useSellarCurrentBusiness();
  const { user } = useSellarUser();
  const isLoggedIn = !!business && !!user;
  const [searchParams] = useSearchParams();
  const [, setOnboardingContinueUrl] = useLocalStorage(
    "onboardingContinueUrl",
    "",
  );

  const { setShowLoginTitle, setSignupDialogActive } = useSignupContext();

  if (isStorefrontLinkPreview || isLoggedIn) return;

  const storefrontLink =
    searchParams.get("storefrontLink") || searchParams.get("priceTierLink");

  const signUpLogin = (login: boolean) => {
    const continueSearchParams = generateSignupContinueUrl(
      supplier?.id,
      storefrontLink ? `storefrontLink=${storefrontLink}` : "",
    );
    setOnboardingContinueUrl(
      `${continueSearchParams.get("continue")}${
        continueSearchParams.get("queryParameters")
          ? `?${continueSearchParams.get("queryParameters")}`
          : ""
      }`,
    );

    setShowLoginTitle(login);
    setSignupDialogActive(true);
  };

  return (
    <div
      className={`sticky bottom-0 ${zLayer.pinned} col-span-3 mx-auto mb-4 w-full p-4 md:bottom-8 md:max-w-3xl md:flex-row`}
    >
      <div className="flex w-full flex-col items-center justify-between rounded-lg border border-zinc-300 bg-zinc-50 p-4 shadow-lg md:flex-row md:gap-4">
        <div className="mb-4 flex items-center gap-4 md:mb-0">
          <ProfilePicture
            logoUrl={supplier?.Business.logoUrl}
            fallback="supplier-badge"
            size="medium"
          />
          <p className="text-base font-semibold text-zinc-800 md:text-center">
            Sign up to access {supplier?.Business.name}'s trade pricing
          </p>
        </div>
        <Button
          className={"order-3 w-full md:order-2 md:w-[120px]"}
          color="transparent"
          size="small"
          onClick={() => signUpLogin(true)}
        >
          Log in
        </Button>
        <Button
          className={"w-full md:order-3 md:w-[120px]"}
          color="purple"
          size="small"
          onClick={() => signUpLogin(false)}
        >
          Sign up
        </Button>
      </div>
    </div>
  );
};
